import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createQASlice } from "./slices/qa";
import { createSessionSlice } from "./slices/session";
import { createSettingsSlice } from "./slices/settings";
import { createSpotlightSlice } from "./slices/spotlight";
import { createTelemetrySlice } from "./slices/telemetry";
import { createUISlice } from "./slices/ui";

export type LiveStore = ReturnType<typeof createSettingsSlice> &
  ReturnType<typeof createUISlice> &
  ReturnType<typeof createSessionSlice> &
  ReturnType<typeof createQASlice> &
  ReturnType<typeof createSpotlightSlice> &
  ReturnType<typeof createTelemetrySlice>;

export const useLiveStore = create<LiveStore>()(
  persist(
    (...a) => ({
      ...createSettingsSlice(...a),
      ...createUISlice(...a),
      ...createSessionSlice(...a),
      ...createQASlice(...a),
      ...createSpotlightSlice(...a),
      ...createTelemetrySlice(...a),
    }),
    {
      name: "circle-live-storage",
      version: 3,
      partialize: state => ({
        settings: state.settings,
      }),
    },
  ),
);
